import React, { FC, useState, useRef, useMemo } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter, useIonViewDidEnter } from '@ionic/react'
import { MyCardItem, MyCardDetail, MktEmpty } from '@cps'
import { memberMobx, memberCardMobx } from '@mobxStore'
import { cloneDeep, findIndex, find } from '@dt/fe-utils/dist/lodash'
import { useHistoryNew, modalLayer } from '@utils'
import { MktHeader } from 'pages/mkt/components'
import mktController from 'controllers/mktController'
import './index.scss'

import noMemberCardImg from '@img/no-membercard.png'

interface IProps extends IPage, RouteComponentProps {
}

const Card: FC<IProps> = ({ pageName, match, location }) => {
  const history = useHistoryNew()
  const { cardId } = match.params as any
  const [myCards, setMyCards] = useState<IMemberCardInfo[]>([])
  const [anInfo, setAnInfo] = useState<{
    type: 'top-show' | 'move' | '';
    anIndex: number;
    moveY?: number;
  }>({
    type: '',
    anIndex: -1,
  })
  const contentRef = useRef<any>(null)
  const showCardRef = useRef<number>(-1)
  const scrollTop = useRef<number>(0)
  const pageCards = useMemo(() => {
    return myCards.map((item: any) => {
      return memberMobx.cardListMap[item.cardId] || item
    })
  }, [myCards, memberMobx.cardListMap])
  const showMyCard = (info: any) => {
    modalLayer(MyCardDetail, { cardInfo: { detailType: null, ...info } }).then((url: any) => {
      history.push(url)
    }, () => { })
  }
  const getCardList = () => {
    return pageCards.map((item: IMemberCardInfo, index: number) => {
      let anClass = ''
      if (anInfo.type === 'top-show' && anInfo.anIndex === index) {
        anClass = anInfo.type
      }
      if (anInfo.type === 'move' && anInfo.anIndex === index) {
        anClass = anInfo.type
      }
      if (showCardRef.current === item.cardId && anClass !== 'top-show') {
        anClass = 'top-show'
      }
      return (
        <div
          className={`card-blcok ${anClass} ${anInfo.type === 'move' && anClass !== 'move' && 'move-down'}`}
          key={item.cardId}
          style={{
            transform: anClass === 'move' ? `translateY(-${anInfo.moveY}px)` : anInfo.type === 'move' && anClass !== 'move' ? 'translateY(88vh)' : 'none'
          }}

        >
          <MyCardItem detailType={['top-show'].includes(anClass) ? 'open' : 'hide'} source={index === pageCards.length - 1 ? 'home' : 'card'} cardInfo={item} onClick={(e: any) => { cardsSort(index, e) }} />
        </div>
      )
    })
  }
  const cardsSort = (sort: number, e: any) => {
    if (sort === 0) {
      contentRef.current.scrollToTop()
      if (anInfo.type === 'top-show') {
        hideCardDetail()
      } else {
        setAnInfo({
          type: 'top-show',
          anIndex: sort
        })
      }
    } else {
      contentRef.current.scrollToTop()
      const pos: number = (e.clientY - e.nativeEvent.offsetY - 58) + scrollTop.current
      setAnInfo({
        type: 'move',
        anIndex: sort,
        moveY: pos
      })
      setTimeout(() => {
        const newCards = cloneDeep(myCards)
        const curCard = newCards.splice(sort, 1)
        const resCard = curCard.concat(newCards)
        saveShowCard(resCard[0].cardId)
        saveShowCardRef(resCard[0].cardId)
        setMyCards(resCard)
        setAnInfo({
          type: 'top-show',
          anIndex: 0
        })
        scrollTop.current = 0
      }, 400)
    }
  }
  const handleScroll = (e: any) => {
    scrollTop.current = e.detail.scrollTop
    if (anInfo.type === '' || anInfo.type === 'move') return
    if (e.detail.scrollTop >= 50) {
      hideCardDetail()
    }
  }
  const hideCardDetail = () => {
    saveShowCard(-1)
    saveShowCardRef(-1)
    setAnInfo({
      type: '',
      anIndex: -1
    })
  }
  const saveShowCardRef = (cardId?: number) => {
    if (cardId === undefined) {
      const iCardShowId = localStorage.getItem(`ls.iCardShowId.${memberMobx.brandId}`)
      if (iCardShowId) showCardRef.current = parseInt(iCardShowId)
    } else {
      showCardRef.current = cardId
    }
  }
  const saveShowCard = (cardId: number) => {
    if (cardId === -1) {
      localStorage.removeItem(`ls.iCardShowId.${memberMobx.brandId}`)
    } else {
      localStorage.setItem(`ls.iCardShowId.${memberMobx.brandId}`, `${cardId}`)
    }
  }
  const _noHasCards = useMemo(() => {
    const getCardArr: any[] = memberCardMobx.cardList.filter((item: any) => {
      const hasItem: any = find(memberMobx.cardList, (m: any) => m.cardId === item.cardId)
      return !hasItem
    })
    return getCardArr
  }, [memberCardMobx.cardList, memberMobx.cardList])
  useIonViewWillEnter(async () => {
    const cards: IMemberCardInfo[] = await memberMobx.getMemberCards()
    if (cardId) {
      const hasItem = findIndex(cards, (m: IMemberCardInfo) => `${m.cardId}` === cardId)
      if (hasItem >= 0) {
        const curCard = cards.splice(hasItem, 1)
        const resCard = curCard.concat(cards)
        saveShowCard(resCard[0].cardId)
        setMyCards(resCard)
      } else {
        history.replace('/iCard/cardOpen/open/' + cardId)
      }
    } else {
      const currentCardId = showCardRef.current > 0 ? showCardRef.current : null
      const defaultCardId = cards[0]?.isDefault ? cards[0].cardId : null
      const iCardShowId = currentCardId || defaultCardId || localStorage.getItem(`ls.iCardShowId.${memberMobx.brandId}`)
      if (iCardShowId) {
        const hasItem = findIndex(cards, (m: IMemberCardInfo) => `${m.cardId}` === `${iCardShowId}`)
        if (hasItem >= 0) {
          const curCard = cards.splice(hasItem, 1)
          const resCard = curCard.concat(cards)
          saveShowCard(resCard[0].cardId)
          setMyCards(resCard)
        } else {
          if (cards[0]) saveShowCard(cards[0].cardId)
          setMyCards(cards)
        }
      } else {
        if (cards[0]) saveShowCard(cards[0].cardId)
        setMyCards(cards)
      }
    }
    setAnInfo({
      type: 'top-show',
      anIndex: 0,
    })
    saveShowCardRef()
  })
  useIonViewDidEnter(async () => {
    if (memberMobx.isLogin) {
      const getCards: IMemberCardInfo[] = await memberCardMobx.getCardList()
      if (getCards?.length && !memberMobx.cardList.length) {
        if (getCards.length === 1 || cardId) {
          history.replace(`/iCard/cardOpen/open/${cardId || getCards[0].cardId}`)
        } else {
          history.replace('/memberCard/cardApply')
        }
      }
    }
  }, [])
  return (
    <IonPage className='my-card-page'>
      <MktHeader onBack={() => mktController.goBack(history)} title={i18n.t(pageName)}>
        {!!_noHasCards.length && <div data-cypid='mmgToApplyForMCard' className='apply-card-tit' onClick={() => history.push('/memberCard/cardApply')}><i className='iconfont icon-shenling'></i>{i18n.t('mkt.member.applymoreCard')}</div>}
      </MktHeader>
      <IonContent ref={contentRef} className='page-content' scrollEvents onIonScroll={handleScroll}>
        {!myCards.length && <MktEmpty img={noMemberCardImg} text={i18n.t('mkt.member.noCardTip')}></MktEmpty>}
        {myCards.length > 0 && <div className='card-list'>{getCardList()}</div>}
        {myCards.length > 2 && anInfo.type === 'top-show' && <div data-cypid='mmgCollapseMCard' className='pull-up' onClick={hideCardDetail}><div className='pull-up-tip'>{i18n.t('mkt.member.pullUp')}<i className='iconfont icon-daohangzhankai'></i></div></div>}
      </IonContent>
    </IonPage>
  )
}

export default observer(Card)
